import { Link, useLocation } from "react-router-dom";
import Profile from "./Profile";
import { Button } from "@/components/ui/button";

export default function CatchAll() {
  const loc = useLocation();
  if (loc.pathname.startsWith("/@")) {
    const handle = decodeURIComponent(loc.pathname.slice(2)).split("/")[0];
    if (handle) return <Profile handle={handle} />;
  }
  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center">
      <p className="text-7xl font-head font-black text-gradient">404</p>
      <h1 className="font-head text-2xl font-bold mt-4">Page not found</h1>
      <p className="text-muted-foreground mt-2">The page you're looking for doesn't exist or was moved.</p>
      <Link to="/"><Button className="rounded-full bg-neon-pink hover:bg-neon-pink/90 font-bold mt-6">Back home</Button></Link>
    </div>
  );
}
